'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Country2) {
  Country2["SWEDEN"] = "SE";
  Country2["NORWAY"] = "NO";
  Country2["FINLAND"] = "FI";
  Country2["UNITED_KINGDOM"] = "GB";
  Country2["ALBANIA"] = "AL";
  Country2["ANDORRA"] = "AD";
  Country2["ARGENTINA"] = "AR";
  Country2["AUSTRIA"] = "AT";
  Country2["BAHRAIN"] = "BH";
  Country2["BANGLADESH"] = "BD";
  Country2["BELARUS"] = "BY";
  Country2["BOLIVIA"] = "BO";
  Country2["BOSNIA_AND_HERZEGOVINA"] = "BA";
  Country2["BRAZIL"] = "BR";
  Country2["BRUNEI_DARUSSALAM"] = "BN";
  Country2["CANADA"] = "CA";
  Country2["CHILE"] = "CL";
  Country2["COLOMBIA"] = "CO";
  Country2["CROATIA"] = "HR";
  Country2["DENMARK"] = "DA";
  Country2["ESTONIA"] = "EE";
  Country2["FALKLAND_ISLANDS"] = "FK";
  Country2["GEORGIA"] = "GE";
  Country2["GERMANY"] = "DE";
  Country2["GIBRALTAR"] = "GI";
  Country2["GUERNSEY"] = "GG";
  Country2["HEARD_ISLAND_AND_MCDONALD_ISLANDS"] = "HM";
  Country2["HUNGARY"] = "HU";
  Country2["ICELAND"] = "IS";
  Country2["INDIA"] = "IN";
  Country2["IRELAND"] = "IE";
  Country2["ISLE_OF_MAN"] = "IM";
  Country2["JAPAN"] = "JP";
  Country2["JERSEY"] = "JE";
  Country2["KOREA"] = "KR";
  Country2["LATVIA"] = "LV";
  Country2["LIECHTENSTEIN"] = "LI";
  Country2["LITHUANIA"] = "LT";
  Country2["LUXEMBOURG"] = "LU";
  Country2["MACAO"] = "MO";
  Country2["MACEDONIA"] = "MK";
  Country2["MALTA"] = "MT";
  Country2["MEXICO"] = "MX";
  Country2["MOLDOVA"] = "MD";
  Country2["MONACO"] = "MC";
  Country2["MONGOLIA"] = "MN";
  Country2["MONTENEGRO"] = "ME";
  Country2["NETHERLANDS"] = "NL";
  Country2["NEW_ZEALAND"] = "NZ";
  Country2["PARAGUAY"] = "PY";
  Country2["PERU"] = "PE";
  Country2["SPAIN"] = "ES";
  Country2["QATAR"] = "QA";
  Country2["ROMANIA"] = "RO";
  Country2["RUSSIA"] = "RU";
  Country2["SAN_MARINO"] = "SM";
  Country2["SERBIA"] = "RS";
  Country2["SOUTH_AFRICA"] = "ZA";
  Country2["SRI_LANKA"] = "LK";
  Country2["SWITZERLAND"] = "CH";
  Country2["TAIWAN"] = "TW";
  Country2["THAILAND"] = "TH";
  Country2["UKRAINE"] = "UA";
  Country2["UNITED_ARAB_EMIRATES"] = "AE";
  Country2["VENEZUELA"] = "VE";
  Country2["VIETNAM"] = "VN";
})(exports.Country || (exports.Country = {}));
